<template>
    <div class="home">
        <b-container fluid>
            <div>
                <b-row>
                    <b-col>
                        <b-alert variant="warning" dismissible :show="($v.confirmSpouse.$invalid || $v.confirmParent.$invalid) && submitted">
                            You are not eligible for this product.
                            <p>
                                <router-link :to="{name: 'product-select'}">
                                    Return to Product Selection
                                </router-link>
                            </p>
                        </b-alert>
                    </b-col>
                </b-row>
            </div>
            <b-form class="mt-3">
                <b-row class="mt-4" v-if="isNotDeathNoncertified && !isHomeless">
                    <b-col cols="12">
                        <BaseSelector v-model="details.relationship"
                                      :v="$v.details.relationship"
                                      :label="isDeathCategory ? 'How are you related to the decedent?' :
                                                isParentageCategory ? 'What is your relationship to the child on the paternity form?'
                                                :'How are you related to the child/subject?'"
                                      setId="relationship"
                                      :options = relationshipOptions
                                      textField="description"
                                      valueField="code"
                        />
                    </b-col>
                    <b-col cols="6" v-if="isCertifiedRecord || isDeathVa || isBirthVa">
                      <BaseTypableDateInput v-model="customerDob"
                                            :v="$v.customerDob"
                                            label="What is your date of birth?"
                                            slug="customerDob"
                                            :messages="customerDobMessages"
                      />
                    </b-col>
                </b-row>
                <b-row v-if="isBirthCategory || isDeathCategory || isParentageCategory">
                    <b-col v-if="isAdoptionAgency">
                      <p><b>You will need to upload a copy of your adoption agency employee ID during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isAuthorizedRep">
                      <p><b>You must upload a signed statement from a person eligible to request the record.
                        The statement must authorize you to get the certificate on their behalf,
                        include the subject's full name, date of birth, parents' names, and the eligible person's
                        relationship to the subject named on the record.</b></p>
                    </b-col>
                    <b-col v-if="isCourtOrder">
                      <p><b>You will need to upload a court order releasing copies of the record to you during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isChildParentSiblingSpouseGrandparentGrandchildPersonalrepSuccessorTrustee">
                      <p><b>You will need to upload a copy of your notarized identity verification form during checkout</b></p>
                    </b-col>
                    <b-col v-if="isDetermination">
                      <p v-if="isBirthCategory"><b>You will need to upload documentation that a certified copy of the birth record is necessary during checkout.</b></p>
                      <p v-if="isDeathCategory"><b>You will need to upload documentation that a certified death record is necessary for the determination or protection of a personal or property right.</b></p>
                    </b-col>
                    <b-col v-if="isHealthcareAgent">
                      <p><b>You will need to upload a copy of the healthcare power of attorney during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isConservator">
                      <p><b>You will need to upload a copy of a court order showing your legal relationship to the subject named on the record during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isCustodian">
                      <p><b>You will need to upload a copy of a court order showing your legal relationship to the subject named on the record during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isGuardian">
                      <p><b>You will need to upload a copy of a court order showing your legal relationship to the subject named on the record during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isGov">
                      <p><b>You will need to upload a copy of your government employee ID during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isMNChildSupport">
                      <p><b>You will need to upload a copy of your Minnesota program employee ID during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isMNChildWelfare">
                      <p><b>You will need to upload a copy of your Minnesota program employee ID during checkout.</b></p>
                    </b-col>
                    <b-col v-if="isMNCare">
                      <p><b>You will need to upload a copy of your Minnesota program employee ID during checkout.</b></p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col v-if="isAttorney || isAttorneyNonMN" cols="4">
                        <BaseTextInput v-model="details.license"
                                       :v="$v.details.license"
                                       slug="license"
                                       label="Attorney license number"
                                       setId="attorneyLicenseNumber"
                                       maxlength="25"/>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col v-if="isAttorney">
                    <p><b>You will need to upload a copy of your attorney license during checkout</b></p>
                  </b-col>
                  <b-col v-if="isAttorneyNonMN">
                    <p><b>You will need to upload a copy of your attorneys’ bar association card during checkout</b></p>
                  </b-col>
                    <b-col v-if="isDetermination">
                        <BaseParagraphInput v-model="details.interestStatement"
                                            :v="$v.details.interestStatement"
                                            label="Explanation of interest"
                                            slug="interestStatement"
                                            setId="interestStatement"
                                            maxlength="256"
                        />
                    </b-col>
                    <b-col v-if="isOther && isDeathCategory">
                        You are not eligible for this product.  You may order the following Death Record products:
                        <p>
                            <router-link :to="{name: 'death-noncertified'}">
                                Informational Noncertified Death Record
                            </router-link>
                        </p>
                    </b-col>
                </b-row>
                <div v-if="!isOther">
                    <b-row v-if="isBeforeAdoptionParent">
                      <b-col cols="2">
                        <BaseCheckboxInput label="Check the box to confirm you are a parent named on the original birth record."
                                           v-model="confirmParent"
                                           :v="$v.confirmParent"
                                           slug="preAdoptPt"
                                           setId="beforeAdoptionParent"
                                           :messages="beforeAdoptionParentMessages"
                          />
                      </b-col>
                    </b-row>
                  <b-row v-if="isMother">
                    <b-col cols="2">
                      <BaseCheckboxInput label="Check the box to confirm you are the birth mother"
                                         v-model="confirmParent"
                                         :v="$v.confirmParent"
                                         slug="mother"
                                         setId="mother"
                                         :messages="motherMessages"
                      />
                    </b-col>
                  </b-row>
                    <b-row v-if="isSpouseOrDescendent">
                        <b-col cols="2">
                            <BaseCheckboxInput label="I confirm that the adopted person is deceased"
                                               v-model="details.subject.dead"
                                               :v="$v.details.subject.dead"
                                               slug="dead"
                                               setId="dead"
                            />
                        </b-col>
                        <b-col v-if="details.subject.dead" cols="10">
                            <BaseTextInput v-model="details.subject.placeOfDeath"
                                           :v="$v.details.subject.placeOfDeath"
                                           slug="placeOfDeath"
                                           label="Place of death"
                                           tip="Include city, state, & country of death if known"
                                           maxlength="255"/>
                        </b-col>
                    </b-row>
                    <b-row v-if="isCurrentSpouse">
                        <b-col cols="2">
                            <BaseCheckboxInput label="Check the box to confirm you are the current spouse of the subject of the record"
                                               v-model="confirmSpouse"
                                               :v="$v.confirmSpouse"
                                               slug="dead"
                                               setId="dead"
                                               :messages="currentSpouseMessages"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="isRecordSpouse">
                        <b-col cols="2">
                            <BaseCheckboxInput label="Check the box to confirm you are the spouse on the record"
                                               v-model="confirmSpouse"
                                               :v="$v.confirmSpouse"
                                               slug="dead"
                                               setId="dead"
                                               :messages="recordSpouseMessages"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="isHomeless">
                      <b-col cols="2">
                        <BaseCheckboxInput label="I am a homeless youth and I am requesting my own birth record, and I certify that the information provided on this application is correct and complete to the best of my knowledge."
                                           v-model="confirmHomeless"
                                           :v="$v.confirmHomeless"
                                           slug="dead"
                                           setId="dead"
                                           :messages="recordHomelessMessages"
                        />
                      </b-col>
                      <b-col>
                        <div class="font-weight-bold">
                          Homeless youth definition
                        </div>
                        <div>
                          Minnesota Statutes, section 256K.45, subdivision 1a, paragraph (c), defines “homeless youth" as a
                          person 24 years of age or younger who
                          <ul class="list-disc">
                            <li>
                              is unaccompanied by a parent or guardian and is without shelter where care and supervision are available.
                            </li>
                            <li>
                              has a parent or legal guardian who is unable or unwilling to shelter and care for them.
                            </li>
                            <li>
                              lacks a fixed, regular, and adequate nighttime residence.
                            </li>
                          </ul>
                          The following are not "fixed, regular, or adequate nighttime residences":
                          <ol>
                            <li>
                              A supervised publicly, or privately operated shelter designed to offer temporary living accommodations.
                            </li>
                            <li>
                              An institution or a publicly or privately operated shelter designed to offer temporary living
                              accommodations.
                            </li>
                            <li>
                              Transitional housing.
                            </li>
                            <li>
                              A temporary placement with a peer, friend, or family member that has not offered a permanent residence,
                              a residential lease, or temporary lodging for more than 30 days.
                            </li>
                            <li>
                              A public or private place not designed for, nor ordinarily used as, a regular sleeping accommodation for
                              human beings.
                            </li>
                          </ol>
                          Homeless youth does not include persons incarcerated or otherwise detained under federal or state law.
                        </div>
                      </b-col>
                    </b-row>
                    <h5 class="m-3">
                      {{nameText}}
                    </h5>
                    <b-row>
                        <b-col>
                            <BaseTextInput v-model="details.subject.name.firstName"
                                           :v="$v.details.subject.name.firstName"
                                           slug="firstName"
                                           setId="firstName"
                                           :label="isDeathCategory ? 'Decedent first name' : isStillbirthCategory ? 'Stillborn first name'
                                           : isBirthChangesProduct || isParentageCategory || isBirthVa || isHomeless ? 'Subject first name' : 'First name'"
                                           maxlength="50"
                            />
                        </b-col>
                        <b-col>
                            <BaseTextInput v-model="details.subject.name.lastName"
                                           :v="$v.details.subject.name.lastName"
                                           slug="lastName"
                                           setId="lastName"
                                           :label="isDeathCategory ? 'Decedent last name' : isStillbirthCategory ? 'Stillborn last name'
                                           : isBirthChangesProduct || isParentageCategory || isBirthVa || isHomeless ? 'Subject last name' : 'Last name'"
                                           maxlength="50"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <BaseTextInput v-model="details.subject.name.middleName"
                                           :v="$v.details.subject.name.middleName"
                                           slug="middleName"
                                           setId="middleName"
                                           :label="isDeathCategory ? 'Decedent middle name' : isStillbirthCategory ? 'Stillborn middle name'
                                           : isBirthChangesProduct || isParentageCategory || isBirthVa || isHomeless ? 'Subject middle name' : 'Middle name'"
                                           maxlength="50"
                            />
                        </b-col>
                        <b-col v-if="!isStillbirthCategory && !isBirthChangesProduct && !isParentageCategory && !isBirthVa && !isHomeless">
                            <BaseTextInput v-model="details.subject.name.suffix"
                                           :v="$v.details.subject.name.suffix"
                                           slug="suffix"
                                           setId="suffix"
                                           :label="isDeathCategory ? 'Decedent suffix' : 'Suffix'"
                                           maxlength="10"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="isStillbirthCategory || isBirthCategory || isParentageCategory || isCertifiedDeathRecord" >
                      <b-col cols="6">
                        <BaseSelector v-model="details.subject.sex"
                                                :v="$v.details.subject.sex"
                                                slug="sex"
                                                :label="isStillbirthCategory ? 'Stillborn\'s sex'
                                                : isHomeless ? 'What is the sex on your birth record?'
                                                : isCertifiedDeathRecord ? 'What is the sex on the Death record?' : 'What is the sex on the birth record?'"
                                                :options=sexOptions
                                                setId="Subject's sex dropdown"
                        />
                      </b-col>
                    </b-row>
                    <h5 class="m-3"  v-if="isStillbirthCategory">When did the delivery occur?</h5>
                    <b-row v-if="isStillbirthCategory">
                      <b-col cols="2" offset="5">
                        <BaseTypableDateInput  v-model="details.subject.dateOfDelivery"
                                               :v="$v.details.subject.dateOfDelivery"
                                               slug="dateOfDelivery"
                                               label="Date of delivery"
                                               :messages="opts.dateMessages"
                        />
                      </b-col>
                    </b-row>
                    <h5 class="m-3" v-if="(isBirthCategory || isParentageCategory) && !isHomeless">When did the birth occur?</h5>
                    <h5 class="m-3" v-if="isHomeless">When were you born?</h5>
                    <b-row v-if="isBirthCategory || isParentageCategory || isCertifiedDeathRecord">
                      <b-col cols="6">
                        <BaseTypableDateInput  v-model="details.subject.dateOfBirth"
                                               :v="$v.details.subject.dateOfBirth"
                                               slug="dateOfBirth"
                                               :label="isParentageCategory || isBirthVa || isHomeless ? 'Date of birth' : isDeathCategory ? 'Decedent date of birth' : 'Subject date of birth'"
                                               :messages="opts.dateMessages"
                        />
                      </b-col>
                    </b-row>
                    <h5 class="text-sm-start text-md-center"  v-if="!isStillbirthCategory && !isBirthChangesProduct && !isParentageCategory
                      && !isBirthVa && !isHomeless && !isDeathVa">
                      What is the state file number?
                    </h5>
                    <h5 class="text-sm-start text-md-center"  v-if="isParentageCategory || isBirthVa || isHomeless || isDeathVa">
                      What is the state file number, if known?
                    </h5>
                    <b-row v-if="!isBirthChangesProduct">
                        <b-col sm="6" md="2" offset-sm="0" offset-md="5">
                            <BaseMaskedTextInput v-model="details.subject.stateFileNumber"
                                             :v="$v.details.subject.stateFileNumber"
                                             slug="stateID"
                                             label="State file number"
                                             placeholder="YYYY-MN-######"
                                             mask="####-AA-######"
                                             v-if="!isStillbirthCategory"
                            />
                        </b-col>
                    </b-row>
                    <div v-if="isDeathCategory || isStillbirthCategory || isBirthCategory || isParentageCategory">
                        <h5 class="m-3" v-if="isDeathCategory">Where did the death occur?</h5>
                        <h5 class="m-3" v-if="isStillbirthCategory">Where did the delivery occur?</h5>
                        <h5 class="m-3" v-if="isBirthCategory && !isNoncertifiedAdopted && !isBirthVa && !isHomeless">Where did the birth occur?</h5>
                        <h5 class="m-3" v-if="(isBirthCategory && (isNoncertifiedAdopted || isBirthVa)) || isParentageCategory">Where did the birth take place?</h5>
                        <h5 class="m-3" v-if="isHomeless">Where were you born?</h5>
                        <b-row>
                            <b-col>
                                <BaseSearchableSelector v-model="details.subject.address.county"
                                                        :v="$v.details.subject.address.county"
                                                        :label="(isBirthChangesProduct || isBirthCategory) && !isBirthVa && !isHomeless ? 'Subject county of birth' : 'County'"
                                                        :options = countyOptions
                                                        @input="updateCityOptions"
                                />
                            </b-col>
                            <b-col>
                                <BaseSearchableSelector v-model="details.subject.address.mnCity"
                                                        :v="$v.details.subject.address.mnCity"
                                                        :label="(isBirthChangesProduct || isBirthCategory) && !isBirthVa && !isHomeless ? 'Subject city of birth' : 'City'"
                                                        :options = cityOptions
                                                        @input="updateCountyOptions"
                                />
                            </b-col>
                        </b-row>
                        <b-row v-if="!isBirthChangesProduct">
                            <b-col cols="4">
                                <BaseSelector v-model="details.subject.address.state"
                                              :v="$v.details.subject.address.state"
                                              label="State"
                                              slug="state"
                                              :options=opts.stateOptions
                                              :plaintext="true"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="isNoncertifiedAdopted">
                      <h5 class="m-3">When did the subject's death occur?</h5>
                      <b-row>
                        <b-col>
                          <BaseTypableDateInput  v-model="details.subject.dateOfDeath"
                                                 :v="$v.details.subject.dateOfDeath"
                                                 slug="dateOfDeath"
                                                 label="Date of death"
                                                 :messages="opts.dateMessages"
                          />
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="isDeathCategory || (isSpouseOrDescendent && details.subject.dead)">
                        <h5 class="m-3">When did the death occur?</h5>
                        <b-row>
                            <b-col>
                                <BaseTypableDateInput  v-model="details.subject.dateOfDeath"
                                                       :v="$v.details.subject.dateOfDeath"
                                                       slug="dateOfDeath"
                                                       label="Date of death"
                                                       :messages="opts.dateMessages"
                                />
                            </b-col>
                        </b-row>
                    </div>
                    <h5 class="m-3" v-if="!isBirthChangesProduct">Name of parent(s)</h5>
                    <div v-for="(parent, index) in details.subject.parents" v-bind:key="index">
                        <b-row>
                            <b-col>
                                <BaseTextInput v-model="parent.name.firstName"
                                               :v="$v.details.subject.parents.$each[index].name.firstName"
                                               slug='parentFirstName'
                                               :label="'Parent '+ (index + 1) + ' first name'"
                                               :setId="'FirstName' + index"
                                               maxlength="50"
                                />
                            </b-col>
                            <b-col>
                                <BaseTextInput v-model="parent.name.lastName"
                                               :v="$v.details.subject.parents.$each[index].name.lastName"
                                               slug="parentLastName"
                                               :label="'Parent '+ (index + 1) + ' last name on the record'"
                                               :setId="'Last Name' + index"
                                               maxlength="50"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <BaseTextInput v-model="parent.name.middleName"
                                               :v="$v.details.subject.parents.$each[index].name.middleName"
                                               slug="parentMiddleName"
                                               :label="'Parent '+ (index + 1) + ' middle name'"
                                               :setId="'Middle Name' + index"
                                />
                            </b-col>
                            <b-col cols="6" v-if="isStillbirthCategory || isParentageCategory">
                              <BaseTextInput v-model="parent.name.previousLastName"
                                             :v="$v.details.subject.parents.$each[index].name.previousLastName"
                                             slug="parentPreviousLastName"
                                             :label="isParentageCategory && index === 0 ? 'Maiden name' : 'Parent '+ (index + 1) + ' last name before first marriage'"
                                             :setId="'Previous Last Name' + index"
                              />
                            </b-col>
                        </b-row>
                        <b-row v-if="!isBirthChangesProduct && product.category === 'BIRTH'">
                            <b-col cols="4" v-if="details.subject.parents.length > 1">
                                <b-button @click="removeParent(index, false)">Remove Parent</b-button>
                            </b-col>
                        </b-row>
                        <b-row v-if="details.subject.parents.length < 2">
                            <b-col>
                                <b-button @click="addParent(false)">Add Second Parent</b-button>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="isNoncertifiedAdopted">
                      <h5 class="m-3">Name of birth parent(s)</h5>
                      <div v-for="(bparent, index) in details.subject.birthParents" v-bind:key="'birth' + index">
                        <b-row>
                          <b-col>
                            <BaseTextInput v-model="bparent.name.firstName"
                                           :v="$v.details.subject.birthParents.$each[index].name.firstName"
                                           slug='birthParentFirstName'
                                           :label="'Birth parent '+ (index + 1) + ' first name'"
                                           :setId="'bpFirstName' + index"
                                           maxlength="50"
                            />
                          </b-col>
                          <b-col>
                            <BaseTextInput v-model="bparent.name.lastName"
                                           :v="$v.details.subject.birthParents.$each[index].name.lastName"
                                           slug="birthParentLastName"
                                           :label="'Birth parent '+ (index + 1) + ' last name'"
                                           :setId="'bpLast Name' + index"
                                           maxlength="50"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="6">
                            <BaseTextInput v-model="bparent.name.middleName"
                                           :v="$v.details.subject.birthParents.$each[index].name.middleName"
                                           slug="birthParentMiddleName"
                                           :label="'Birth parent '+ (index + 1) + ' middle name'"
                                           :setId="'bpMiddle Name' + index"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="4" v-if="details.subject.birthParents.length > 1">
                            <b-button @click="removeParent(index, true)">Remove Birth Parent</b-button>
                          </b-col>
                        </b-row>
                        <b-row v-if="details.subject.birthParents.length < 2">
                          <b-col>
                            <b-button @click="addParent(true)">Add Second Birth Parent</b-button>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <div v-if="!isStillbirthCategory && !isBirthCategory && (!isParentageCategory || isSnps)">
                      <h5 class="m-3" v-if="!isSnps">Spouse named on record</h5>
                      <h5 class="m-3" v-else>Name of Spouse (who signed the form)</h5>
                      <b-row>
                          <b-col>
                              <BaseTextInput v-model="details.subject.spouse.firstName"
                                             :v="$v.details.subject.spouse.firstName"
                                             slug="spouseFirstName"
                                             label="Spouse first name"
                                             setId="spouse first name"
                                             maxlength="50"
                              />
                          </b-col>
                          <b-col>
                              <BaseTextInput v-model="details.subject.spouse.lastName"
                                             :v="$v.details.subject.spouse.lastName"
                                             slug="spouseLastName"
                                             label="Spouse last name"
                                             setId="spouse last name"
                                             maxlength="50"
                              />
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col cols="6">
                              <BaseTextInput v-model="details.subject.spouse.middleName"
                                             :v="$v.details.subject.spouse.middleName"
                                             slug="spousemiddleName"
                                             label="Spouse middle name"
                                             setId="spouse middle name"
                                             maxlength="50"
                              />
                          </b-col>
                      </b-row>
                    </div>
                    <div v-if="isBirthChangesProduct">
                      <h5 class="m-3">Required - Requester Information</h5>
                        <b-row>
                          <b-col cols="4">
                            <BaseTextInput v-model="requester.firstName"
                                           label="Requester first name"
                                           slug="requesterFirstName"
                                           setId="requesterFirstName"
                                           :v="$v.requester.firstName"
                                           maxLength="100"
                            />
                          </b-col>
                          <b-col cols="4">
                            <BaseTextInput v-model="requester.lastName"
                                           label="Requester last name"
                                           slug="requesterLastName"
                                           setId="requesterLastName"
                                           :v="$v.requester.lastName"
                                           maxLength="100"
                            />
                          </b-col>
                          <b-col cols="4">
                            <BaseTextInput v-model="requester.middleName"
                                           label="Requester middle name"
                                           slug="requesterMiddleName"
                                           setId="requesterMiddleName"
                                           :v="$v.requester.middleName"
                                           maxLength="100"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <BaseParagraphInput v-model="details.interestStatement"
                                                :v="$v.details.interestStatement"
                                                label="Describe the reason for your request"
                                                slug="requesterReason"
                                                tip="350 character limit, including spaces"
                                                setId="requesterReason"
                                                maxlength="350"
                            />
                          </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col cols="2" offset="10" v-if="limitedService.isLimitedCode(this.$route.name)">
                          <BaseTextInput v-model="details.quantity"
                                         label="Quantity to order"
                                         slug="quantity"
                                         setId="quantity to order"
                                         :v="$v.details.quantity"
                                         type="number"
                                         :min="1" :max="1"
                          ></BaseTextInput>
                        </b-col>
                        <b-col cols="2" offset="10" v-else>
                          <BaseTextInput v-model="details.quantity"
                                         label="Quantity to order"
                                         slug="quantity"
                                         setId="quantity to order"
                                         :v="$v.details.quantity"
                                         type="number"
                                         :min="1"
                          ></BaseTextInput>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="2" offset="10">
                            <b-button type="button" variant="primary" @click="submit()">Add to Cart</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-form>

        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import BaseSelector from '@/components/templates/input/BaseSelector';
import {required, requiredIf, maxLength, helpers, minValue, minLength} from 'vuelidate/lib/validators'
import BaseTextInput from "@/components/templates/input/BaseTextInput";
import BaseTypableDateInput from "@/components/templates/input/BaseTypableDateInput";
import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput.vue";
import {commonOptions} from "@/mixins/commonOptions";
import BaseSearchableSelector from "@/components/templates/input/BaseSearchableSelector";
import maxDate from "@/validators/maxDate";
import {toastService} from "@/mixins/toastService"
import LocalStorageService from "@/common/LocalStorageService";
import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput.vue";
import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput.vue";
import minDate from "@/validators/minDate";
import {limitedService} from "@/mixins/limitedService";
import {orderTypeService} from "@/mixins/orderTypeService";

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

const localStorageService = LocalStorageService.getService();
const patternCheck = helpers.regex('pattern', /^[a-zA-Z0-9\s]+$/)
const customValidator = (value) => !helpers.req(value) ||  value[0] !== undefined

export default {

    components: {
        BaseMaskedTextInput,
        BaseCheckboxInput,
        BaseTypableDateInput,
        BaseSearchableSelector,
        BaseParagraphInput,
        BaseTextInput,
        BaseSelector,
    },

    mixins: [
        commonOptions,
        toastService
    ],

    props: {
        product: [Object]
    },

    data: () => ({
        customerDob: null,
        requester: {
          firstName: null,
          lastName: null,
          middleName: null
        },
        details: {
            orderId: null,
            relationship: null,
            license: null,
            interestStatement: null,
            subject: {
              stateFileNumber: null,
                name: {
                    firstName: null,
                    lastName: null,
                    middleName: null,
                    suffix: null,
                },
                sex: null,
                address: {
                    mnCity: null,
                    county: null,
                    streetAddress: null,
                    zip: null,
                    state: 'MN',
                    addressType: null,
                },
                dateOfDelivery: null,
                dateOfBirth: null,
                dateOfDeath: null,
                dead: false,
                placeOfDeath: null,
                parents: [
                    {
                        name: {
                            id: 1,
                            firstName: null,
                            lastName: null,
                            middleName: null,
                            previousLastName: null,
                        },
                    },
                ],
                birthParents: [
                  {
                    name: {
                      id: 1,
                      firstName: null,
                      lastName: null,
                      middleName: null,
                      previousLastName: null,
                    },
                  },
                ],
                spouse: {
                    firstName: null,
                    lastName: null,
                    middleName: null,
                },
            },
            quantity: 1,
        },
        confirmSpouse: false,
        confirmParent: false,
        confirmHomeless: false,
        nameText: null,
        submitted: false,
        relationshipOptions: [],
        cityOptions: [],
        countyOptions: [],
        sexOptions: [
            {text:'Female', value:'FEMALE'},
            {text: 'Male', value: 'MALE'},
            {text:'Other', value:'OTHER'}
        ],
        currentSpouseMessages: {
            spouseValid: 'Must be the current spouse of the subject of the record to order this product'
        },
        customerDobMessages: {
            customerValid: 'You must enter your date of birth to order this product',
            maxDate: 'Date cannot be in the future.',
            minDate: 'Date cannot be earlier than 1900'
        },
        recordSpouseMessages: {
            spouseValid: 'Must be the spouse on the record to order this product'
        },
        recordHomelessMessages: {
          homelessValid: 'Must be a homeless youth to order this product'
        },
        beforeAdoptionParentMessages: {
            parentValid: 'Must be a parent of the subject of the record to order this product'
        },
        motherMessages: {
            parentValid: 'Must be the mother of the subject of the record to order this product'
        },
        motherRoutes: ['birth-noncertified-health', 'parentage-snps-revocation', 'parentage-snps', 'mfar', 'stillbirth-noncertified-health']
    }),

    computed: {
        limitedService() {
          return limitedService
        },
        isAttorney() {
            return this.details.relationship === "ATTORNEY_MN"
        },
        isAttorneyNonMN() {
          return this.details.relationship === "ATTORNEY"
        },
        isAdoptionAgency() {
          return this.details.relationship === "ADOPT"
        },
        isAuthorizedRep() {
          return this.details.relationship === "AUTH_REP"
        },
        isChildParentSiblingSpouseGrandparentGrandchildPersonalrepSuccessorTrustee() {
          return this.details.relationship === "CHILD" || this.details.relationship === "PARENT" || this.details.relationship === "SIBLING"
              || this.details.relationship === "SPOUSE" || this.details.relationship === "GRANDPARENT" || this.details.relationship === "GRANDCHILD"
              || this.details.relationship === "SUCCESSOR" || this.details.relationship === "TRUSTEE" || this.details.relationship === "REP"
        },
        isCourtOrder() {
          return this.details.relationship === "COURT_ORDER"
        },
        isHealthcareAgent() {
          return this.details.relationship === "HEALTHCARE"
        },
        isConservator() {
          return this.details.relationship === "CONSERVATOR"
        },
        isCustodian() {
          return this.details.relationship === "CUSTODIAN"
        },
        isGuardian() {
          return this.details.relationship === "GUARDIAN"
        },
        isGov() {
          return this.details.relationship === "GOV"
        },
        isMNChildSupport() {
          return this.details.relationship === "MN_CHILD_SUPPORT"
        },
        isMNChildWelfare() {
          return this.details.relationship === "MN_CHILD_WELFARE"
        },
        isMNCare() {
          return this.details.relationship === "MNCARE"
        },
        isDetermination() {
            return this.details.relationship === "DETERMINATION"
        },
        isOther() {
            return this.details.relationship === "OTHER"
        },
        isSelf() {
          return this.details.relationship === "SELF"
        },
        isSuccessor() {
            let relationship = this.details.relationship === "SUCCESSOR"
            let products = ['birth-certified', 'birth-noncertified', 'birth-noncertified-image', 'birth-verification', 'death-certified', 'death-certified-cod', 'death-noncertified']
            let required = relationship && products.includes(this.$route.name)
            return required
        },
        isSpouseOrDescendent() {
            let relations = ["SPOUSE", "CHILD", "GRANDCHILD", "GGRANDCHILD"]
            let required = relations.includes(this.details.relationship) &&  this.$route.name === 'birth-noncertified-original'
            return required
        },
        isCurrentSpouse() {
            let relationship = this.details.relationship === "SPOUSE"
            let products = ['birth-certified', 'birth-noncertified', 'birth-noncertified-image', 'birth-verification']
            let required = relationship && products.includes(this.$route.name)
            return required
        },
        isRecordSpouse() {
            let relationship = this.details.relationship === "SPOUSE"
            let required = relationship && this.product['category'] === 'DEATH'
            return required
        },
        isDeathCategory() {
            return this.product['category'] === 'DEATH'
        },
        isBirthCategory() {
          return this.product['category'] === 'BIRTH'
        },
        isParentageCategory() {
          return this.product['category'] === 'PARENTAGE'
        },
        isNoncertifiedAdopted() {
          return this.$route.name === 'birth-noncertified-adopted'
        },
        isHomeless() {
          return this.$route.name === 'birth-homeless'
        },
        isNotDeathNoncertified() {
            return this.$route.name !== 'death-noncertified'
        },
        isSnps() {
          return this.$route.name === 'parentage-snps' ||  this.$route.name === 'parentage-snps-revocation'
        },
        isCertifiedRecord() {
            return this.$route.name === 'birth-certified' || this.$route.name === 'death-certified-cod' || this.$route.name === 'death-certified'
        },
        isCertifiedDeathRecord() {
            return this.$route.name === 'death-certified-cod' || this.$route.name === 'death-certified' || this.$route.name === 'death-va'
        },
        isStillbirthCategory() {
          return this.product['category'] === 'STILLBIRTH'
        },
        isBirthChangesProduct() {
          return this.$route.name === 'birth-change-summary'
        },
        isBirthVa() {
          return this.$route.name === 'birth-va'
        },
        isDeathVa() {
          return this.$route.name === 'death-va'
        },
        isBeforeAdoptionParent() {
            let relationship = this.details.relationship === "PARENT"
            let required = relationship && this.$route.name === 'birth-noncertified-original' && this.product['category'] === 'BIRTH'
            return required
        },
        isMother() {
          let relationship = this.details.relationship === "PARENT"
          let required = relationship && this.motherRoutes.includes(this.$route.name)
          return required
        },
    },

    watch: {
        'details.relationship'(value) {
            if(this.isAttorney && !this.details.license) {
                this.loadLicense()
            }
        }
    },

    mounted() {
        this.details.subject.address.addressType = this.isBirthCategory ? 'BIRTH' : 'DEATH'
        this.loadOptions()
        this.loadCities()
        this.loadCounties()
        this.loadNameText()
        if (this.isParentageCategory) {
          this.addParent(false)
        }
    },

    methods: {
        loadOptions(){
            let payload = {
                category: this.product['category'],
                code: this.product['code']
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/options/relationship/`, payload)
                .then(response=>{
                    this.relationshipOptions = response.data
                })
        },
        loadCities(){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/city/all`)
                .then(response=>{
                    this.cityOptions = response.data
                })
        },
        loadCounties(){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/county/all`)
                .then(response=>{
                    this.countyOptions = response.data
                })
        },
        loadNameText(){
          this.nameText = this.product['category'] === 'DEATH' ? 'How does the name appear on the death record?'
              : this.isBirthChangesProduct ? 'Required - Information to find birth record'
              : this.isParentageCategory ? 'How does the name appear on the birth record?'
              : this.isHomeless ? 'How does your name appear on the birth record?' :  'How does the name appear on the record?'
        },
        loadLicense() {
            if (this.$keycloak.authenticated) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/license/` + this.$keycloak.subject)
                    .then(response=>{
                        this.details.license = response.data
                    })
            } else if (localStorageService.getOrderNumber() != null) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/license/` + localStorageService.getOrderNumber())
                    .then(response=>{
                        this.details.license = response.data
                    })
            }
        },
        updateCityOptions(county){
            if (county == null) {
                this.loadCities()
            } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/city/${county.label}`)
                    .then(response=>{
                        this.cityOptions = response.data
                        if (this.details.subject.address.mnCity != null
                            && this.cityOptions.findIndex(c => c.id === this.details.subject.address.mnCity.id) === -1) {
                            this.details.subject.address.mnCity = null
                        }
                    })
            }
        },
        updateCountyOptions(city){
            if (city == null) {
                this.loadCounties()
            } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/county/${city.label}`)
                    .then(response=>{
                        this.countyOptions = response.data
                        if (this.details.subject.address.county == null
                            || this.countyOptions.findIndex(c => c.id === this.details.subject.address.county.id) === -1) {
                            this.details.subject.address.county = null
                        }
                    })
            }
        },
        submit() {
            this.$v.$touch()
            this.submitted = true
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    window.scrollTo(0,0);
                });
                return
            }
            if (!orderTypeService.isTypeSet()) {
              localStorageService.setOrderType('N')
            } else if (orderTypeService.isAmendType()) {
              toastService.showRootToast("Error", "You cannot order a non-amendment product with an amendment order.  You must place a separate order for this item." , "danger", this.$root)
              return
            }
            if (localStorageService.getOrderNumber() != null) {
                this.details.orderId = localStorageService.getOrderNumber()
            }
            this.details.product = this.product
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/order`, this.details)
                .then(response=>{
                    localStorageService.setCartItems(Number(localStorageService.getCartItems()) + 1)
                    this.$emit('send-emit', localStorageService.getCartItems())
                    localStorageService.setOrderNumber(response.data)
                    if (this.isCertifiedRecord) {
                        let profile = {dateOfBirth: this.customerDob}
                        axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/setDob/` + localStorageService.getOrderNumber(), profile)
                    }
                    if (this.isBirthChangesProduct) {
                      axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/setName/` + localStorageService.getOrderNumber(), this.requester)
                    }
                    this.$emit('order-emit')
                    toastService.showRootToast("Order Updated", "Product has been added to your order" , "success", this.$root)
                    this.$router.push({ path: '/cart'})
                })
                .catch(err => {
                    if (err?.response?.status === 409) {
                      toastService.showRootToast("Error", "You cannot order a non-amendment product with an amendment order.  You must place a separate order for this item." , "danger", this.$root)
                    } else {
                      toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                    }
            })
        },
        removeParent: function (i, birthParent) {
            if (birthParent) {
                if (this.details.subject.birthParents.length > 1) {
                    this.$delete(this.details.subject.birthParents, i);
                }
            } else {
                if (this.details.subject.parents.length > 1) {
                  this.$delete(this.details.subject.parents, i);
                }
            }
        },
        addParent: function (birthParent) {
            if (birthParent) {
                if (this.details.subject.birthParents.length < 2) {
                  const id = this.details.subject.birthParents.length + 1
                  this.details.subject.birthParents.push({
                    name: {
                      id: id,
                      firstName: null,
                      lastName: null,
                      middleName: null,
                    },
                  });
                }
            } else {
                if (this.details.subject.parents.length < 2) {
                  const id = this.details.subject.parents.length + 1
                  this.details.subject.parents.push({
                    name: {
                      id: id,
                      firstName: null,
                      lastName: null,
                      middleName: null,
                    },
                  });
                }
            }
        },
        initialize() {
          if (this.isHomeless) {
            this.details.relationship = 'SELF'
          }
        }
    },
  validations() {
        return {
            customerDob: {
              customerValid: function() { return this.details.customerDob !== null || !this.isCertifiedRecord},
              required: requiredIf(function () { return this.isCertifiedRecord || this.isDeathVa || this.isBirthVa}),
              maxDate: maxDate(new Date()),
              minDate: minDate(new Date(1900, 0, 1))
            },
            requester: {
              firstName: {required: requiredIf(function(){ return this.isBirthChangesProduct})},
              lastName: {required: requiredIf(function(){ return this.isBirthChangesProduct})},
              middleName: {required:false}
            },
            details: {
                relationship: { required: requiredIf(function () { return this.isNotDeathNoncertified }) },
                license: {
                    required: requiredIf(function(){ return this.isAttorney || this.isAttorneyNonMN}),
                    maxLength: maxLength(25),
                    patternCheck,
                },
                interestStatement: {
                    required: requiredIf(function(){ return this.isDetermination || this.isBirthChangesProduct}),
                    maxLength: this.isDetermination ? maxLength(256) : maxLength(350)
                },
                subject: {
                    required,
                    stateFileNumber: {
                      required : false,
                      maxLength: maxLength(14),
                      minLength: minLength(14),
                    },
                    name: {
                        firstName: {
                            required: requiredIf(function(){ return !this.isStillbirthCategory }),
                            maxLength: maxLength(50)
                        },
                        lastName: {
                            required: requiredIf(function(){ return !this.isStillbirthCategory }),
                            maxLength: maxLength(50)
                        },
                        middleName: {
                            required: requiredIf(function(){ return this.isBirthChangesProduct}),
                            maxLength: maxLength(50)
                        },
                        suffix: {
                            required: false,
                            maxLength: maxLength(10)
                        },
                    },
                    sex: {
                      required: requiredIf(function(){ return this.isParentageCategory || this.isHomeless || this.isBirthVa || this.isCertifiedDeathRecord}),
                      maxLength: maxLength(10)
                    },
                    address: {
                        required: requiredIf(function(){ return this.isDeathCategory }),
                        mnCity: { required: false },
                        county: { required: requiredIf(function(){ return this.isDeathCategory || this.isBirthCategory || this.isParentageCategory }) },
                        streetAddress: { required: false },
                        state: { required: requiredIf(function(){ return this.isDeathCategory }) },
                        zip: { required: false },
                        addressType: { required: requiredIf(function(){ return this.isDeathCategory }) }
                    },
                    dateOfDelivery: {
                      required: requiredIf(function(){ return this.isStillbirthCategory }),
                      maxDate: maxDate(new Date()),
                    },
                    dateOfBirth: {
                      required: requiredIf(function(){ return this.isBirthCategory || this.isParentageCategory }),
                      maxDate: maxDate(new Date()),
                      minDate: minDate(new Date(1900, 0, 1))
                    },
                    dateOfDeath: {
                        required: requiredIf(function(){ return this.isDeathCategory || (this.isSpouseOrDescendent && this.details.subject.dead)
                            || (this.isNoncertifiedAdopted && !this.isAttorney && !this.isAttorneyNonMN && !this.isSelf) }),
                        maxDate: maxDate(new Date()),
                    },
                    dead: {
                        required: requiredIf(function(){ return this.isSuccessor || this.isSpouseOrDescendent })
                    },
                    placeOfDeath: {
                        required: requiredIf(function(){ return this.isSpouseOrDescendent })
                    },
                    parents: {
                        required: false,
                        $each: {
                            name: {
                                firstName: {
                                    required: requiredIf(function(value) {
                                      return (value.id === 1 && (this.isStillbirthCategory || this.isBirthChangesProduct))
                                        || this.isParentageCategory || this.isBirthVa || this.isBirthCategory || this.isDeathCategory
                                    }),
                                    maxLength: maxLength(50)
                                },
                                lastName: {
                                    required: requiredIf(function(value) {
                                      return (value.id === 1 && (this.isStillbirthCategory))
                                          || (value.id === 2 && this.isParentageCategory) || this.isBirthCategory
                                    }),
                                    maxLength: maxLength(50)
                                },
                                middleName: {
                                    required: requiredIf(function(value) {
                                      return value.id === 1 && (this.isBirthChangesProduct)
                                    }),
                                    maxLength: maxLength(50)
                                },
                                previousLastName: {
                                    required:  requiredIf(function(value) {
                                      return value.id === 1 && this.isParentageCategory
                                    }),
                                    maxLength: maxLength(50)
                                }
                            },
                        }
                    },
                    birthParents: {
                      required: false,
                      $each: {
                        name: {
                          firstName: {
                            required: false,
                            maxLength: maxLength(50)
                          },
                          lastName: {
                            required: false,
                            maxLength: maxLength(50)
                          },
                          middleName: {
                            required: false,
                            maxLength: maxLength(50)
                          },
                        },
                      }
                    },
                    spouse: {
                        firstName: {
                            required: requiredIf(function() {
                              return this.isSnps
                            }),
                            maxLength: maxLength(50)
                        },
                        lastName: {
                            required:  requiredIf(function() {
                              return this.isSnps
                            }),
                            maxLength: maxLength(50)
                        },
                        middleName: {
                            required: false,
                            maxLength: maxLength(50)
                        },
                    },
                },
                quantity: { required, minValue: minValue(1), maxValue: function(value, parent) {
                    return (!limitedService.isLimitedCode(this.$route.name) || value <= 1);
                  }
                },
            },
            confirmSpouse: {
                spouseValid: function(){ return !(this.isRecordSpouse || this.isCurrentSpouse)
                    || ((this.isRecordSpouse || this.isCurrentSpouse) && this.confirmSpouse === true) }
            },
            confirmParent: {
              parentValid: function(){
                return !(this.isBeforeAdoptionParent || this.isMother)
                  || ((this.isBeforeAdoptionParent || this.isMother)&& this.confirmParent === true) }
            },
            confirmHomeless: {
              homelessValid: function(){ return !this.isHomeless || (this.isHomeless && this.confirmHomeless === true) }
            },
        }
  },
  created() {
     document.title = "Application Questions - Online Storefront"
     this.initialize()
  },

}
</script>

<style>
 .green-header {
     color: #60A609;
 }
 h5 {
     text-align: center;
     font-weight: bold;
     font-family: inherit;
 }
label {
    font-family: inherit;
    font-weight: bold;
  }
</style>
